var $ = require('jquery');

$('.toggle-responsive-menu').on('click', function (e) {
    e.preventDefault();

    $('.header-wrapper').stop().slideToggle();
});
